
import ReactDOM from 'react-dom/client';
import { CookiesProvider } from "react-cookie";

// REDUX PROVIDER
import { Provider } from 'react-redux'
// STORE
import store from './main/config/store'

import { KitQRForm } from './presentation/components/KitQR/KitQR';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <CookiesProvider>
      <KitQRForm />
    </CookiesProvider>
  </Provider>
);